import { ToggleConfig } from '@ardoq/view-settings';
import { MouseEventHandler, MouseEvent } from 'react';
import { GhostButton } from '@ardoq/button';
import { Icon } from '@ardoq/icons';
import { ViewIds } from '@ardoq/api-types';
import { noop } from 'lodash';
import { SettingsBarPopover } from './SettingsBarPopover';

interface ToggleProps extends ToggleConfig {
  viewId: ViewIds;
  rightAligned?: boolean;
  onClick?: MouseEventHandler;
}

export const Toggle = ({
  viewId,
  id,
  isActive,
  label = '',
  iconName,
  popoverText,
  persistent = true,
  isInverted = false,
  isDisabled = false,
  currentValue = isActive,
  onClick,
  onViewSettingsUpdate = noop,
}: ToggleProps) => {
  const toggleSetting = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    const settings = { [id]: isInverted ? currentValue : !currentValue };
    onViewSettingsUpdate(viewId, settings, persistent);
  };

  return (
    <SettingsBarPopover popoverText={popoverText}>
      <GhostButton
        onClick={e => (onClick ? onClick(e) : toggleSetting(e))}
        data-tooltip-text={popoverText ? undefined : label}
        aria-label={label}
        isActive={
          isActive &&
          !isDisabled /* active disabled state is possible, but we are not using it. */
        }
        isDisabled={isDisabled}
        data-click-id={id}
      >
        <Icon iconName={iconName} />
      </GhostButton>
    </SettingsBarPopover>
  );
};
